import { render, staticRenderFns } from "./AdminTravelServiceByTypeView.vue?vue&type=template&id=7e94f5e5&scoped=true&"
import script from "./AdminTravelServiceByTypeView.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceByTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94f5e5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VCombobox,VDataTable,VIcon,VRow,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e94f5e5')) {
      api.createRecord('7e94f5e5', component.options)
    } else {
      api.reload('7e94f5e5', component.options)
    }
    module.hot.accept("./AdminTravelServiceByTypeView.vue?vue&type=template&id=7e94f5e5&scoped=true&", function () {
      api.rerender('7e94f5e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/travel-service/AdminTravelServiceByTypeView.vue"
export default component.exports